import fetch from 'isomorphic-fetch';
import queryString from 'query-string';
import { SubmissionError } from 'redux-form';
import { checkHttpStatus, parseJSON } from '../utils';
import {
  CONFIG_SET_BACKGROUND_IMAGE,
  CONFIG_SET_BACKGROUND_RESET,
  CONFIG_SET_COUNTRIES,
  CONFIG_SET_CURRENT_SECTION,
  CONFIG_SET_DEFAULT_ITEM,
  CONFIG_SET_INITIAL_LOAD, CONFIG_SET_INITIAL_LOAD_ERROR, CONFIG_SET_LOGO,
  CONFIG_SET_PREVIOUS_PATH, CONFIG_SET_SERVER_ERROR,
  CONFIG_SET_SNAPSHOTS_ENABLED,
  CONFIG_SET_WEBSITE_BACKGROUNDS,
  SET_STATIC_PAGE,
  STATIC_PAGE_LOADING,
} from '../constants';
import ExploreAuth from '../utils/ExploreAuth';
import { currentItemSuccess, setSelectedItem } from './currentItem';

export function setSnapshotsEnabled(snapshotsEnabled) {
  return {
    type: CONFIG_SET_SNAPSHOTS_ENABLED,
    payload: { data: snapshotsEnabled },
  };
}

export function setGlobalCountries(countries) {
  return {
    type: CONFIG_SET_COUNTRIES,
    payload: { data: countries },
  };
}

export function setGlobalWebsiteBackgrounds(websiteBackgrounds) {
  return {
    type: CONFIG_SET_WEBSITE_BACKGROUNDS,
    payload: { data: websiteBackgrounds },
  };
}

export function setCurrentSection(section) {
  return {
    type: CONFIG_SET_CURRENT_SECTION,
    payload: { data: section },
  };
}
export function setStaticPage(data) {
  return {
    type: SET_STATIC_PAGE,
    payload: data,
  };
}
function setStaticPageLoading(value) {
  return {
    type: STATIC_PAGE_LOADING,
    payload: value,
  };
}
export function fetchStaticPage(query) {
  return (dispatch) => {
    dispatch(setStaticPageLoading(true));
    query = decodeURIComponent(query);
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        return fetch(`${SERVER_URL}/get_page.json?page=${query}`, {
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(setStaticPage(response.data));
            dispatch(setStaticPageLoading(false));
          })
          .catch((error) => {
            console.log(error, 'An error occurred');
            dispatch(setStaticPageLoading(false));
            // TODO: we need a promise here because of the tests, find a better way
            return Promise.resolve();
          });
      });
  };
}

export function setError(error) {
  return {
    type: CONFIG_SET_SERVER_ERROR,
    payload: error,
  };
}

export function checkApiStatus() {
  return (dispatch) => {
    return fetch(`${SERVER_URL}/ping`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(() => {
        dispatch(setError(false));
      })
      .catch((err) => {
        dispatch(setError(err));
      });
  };
}

export function setPreviousPath(path) {
  return {
    type: CONFIG_SET_PREVIOUS_PATH,
    payload: { data: path },
  };
}

export function setDefaultItem(item) {
  return {
    type: CONFIG_SET_DEFAULT_ITEM,
    payload: { data: item },
  };
}

export function setInitialLoad(value) {
  return {
    type: CONFIG_SET_INITIAL_LOAD,
    payload: { data: value },
  };
}

export function setInitialLoadError(value) {
  return {
    type: CONFIG_SET_INITIAL_LOAD_ERROR,
    payload: { data: value },
  };
}

export function setLogo(logo) {
  return {
    type: CONFIG_SET_LOGO,
    payload: { logo }
  }
}

export function submitContactUs(formData, removeModal) {
  return (dispatch) => {
    return fetch(`${SERVER_URL}/submit_contact_us`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: queryString.stringify(formData),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(() => {
        setTimeout(() => {
          removeModal();
        }, 5000);
      })
      .catch((error) => {
        console.error(error);
        throw new SubmissionError({ _error: 'Error submitting contact form' });
      });
  };
}

export function submitFeedback(formData) {
  return (dispatch) => {
    return fetch(`${SERVER_URL}/submit_feedback`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: queryString.stringify(formData),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(() => {})
      .catch((error) => {
        console.error(error);
        throw new SubmissionError({ _error: 'Error submitting feedback form' });
      });
  };
}

export function submitVolunteer(formData) {
  return (dispatch) => {
    return fetch(`${SERVER_URL}/submit_volunteer_request`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: queryString.stringify(formData),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(() => {})
      .catch((error) => {
        console.error(error);
        throw new SubmissionError({ _error: 'Error submitting feedback form' });
      });
  };
}

export function submitPartnerMessage(formData) {
  return (dispatch) => {
    return fetch(`${SERVER_URL}/submit_partner_message`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: queryString.stringify(formData),
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(() => {})
      .catch((error) => {
        console.error(error);
        throw new SubmissionError({ _error: 'Error submitting partner message form' });
      });
  };
}

export function setBackgroundImage(image) {
  return {
    type: CONFIG_SET_BACKGROUND_IMAGE,
    payload: { data: image },
  };
}

export function resetBackgroundImageCache() {
  return { type: CONFIG_SET_BACKGROUND_RESET };
}
